const GA4_ID = 'G-8G3W29K47S';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackPageView(path: string) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    send_to: GA4_ID,
  });
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, {
    ...params,
    send_to: GA4_ID,
  });
}

// Convenience helpers for key conversion events
export const analytics = {
  phoneClick: (source?: string) =>
    trackEvent('phone_call_click', { event_category: 'conversion', source }),

  bookingClick: (source?: string) =>
    trackEvent('booking_click', { event_category: 'conversion', source }),

  formSubmit: (formName?: string) =>
    trackEvent('form_submit', { event_category: 'conversion', form_name: formName }),

  thankYouPage: () =>
    trackEvent('conversion_complete', { event_category: 'conversion' }),
};
